import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { CheckoutLayout } from './components/CheckoutLayout';
import { ZipCodeForm } from './components/ZipCodeForm';
import { useTokenExchange } from 'V2/Checkout/hooks/useTokenExchange';
import { TOKEN_ERROR_MESSAGES } from 'V2/Checkout/constants';
import { Spinner } from 'V2/Shared/Spinner';
import styles from './styles.module.css';

export const CheckoutVerification: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const history = useHistory();
  const [isLocked, setIsLocked] = useState(false);
  const { status: tokenStatus, errorMessage } = useTokenExchange(token);

  useEffect(() => {
    switch (tokenStatus) {
      case 'bound':
        history.replace('/checkout/confirmation');
        break;
      case 'verified':
        history.replace('/checkout/pay');
        break;
    }
  }, [tokenStatus, history]);

  if (
    tokenStatus === 'loading' ||
    tokenStatus === 'bound' ||
    tokenStatus === 'verified'
  ) {
    return (
      <CheckoutLayout>
        <Spinner variant="blue" />
      </CheckoutLayout>
    );
  }

  if (tokenStatus !== 'ready') {
    return (
      <CheckoutLayout>
        <p className={styles.statusMessage} data-testid="status-message">
          {errorMessage ?? TOKEN_ERROR_MESSAGES[tokenStatus]}
        </p>
      </CheckoutLayout>
    );
  }

  return (
    <CheckoutLayout>
      <h1 className={styles.title}>Verify your identity</h1>
      <p className={styles.description}>
        Enter the ZIP code associated with your quote to continue.
      </p>
      {isLocked ? (
        <p
          className={styles.lockoutMessage}
          role="alert"
          data-testid="lockout-message"
        >
          Too many attempts. Please try again in 15 minutes.
        </p>
      ) : (
        <ZipCodeForm onLockout={() => setIsLocked(true)} />
      )}
    </CheckoutLayout>
  );
};
